if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const useDrawerPopup = this.cart && this.cart.tagName === 'CART-DRAWER';
        if (useDrawerPopup) {
          // Block any app (WeUpsell etc.) from auto-opening a cart drawer for this add-to-cart
          ProductForm.suppressAutoOpen();
          this.cart.setActiveElement(document.activeElement);
        } else if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        ProductForm.nativeFetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.showAddedPopup(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.showAddedPopup(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }


      /* ---------------------------------------------------------------
         "Added to cart" top banner.
         - Cart drawer is refreshed silently (NOT opened).
         - Drawer only opens from "View cart" or the header cart icon.
         --------------------------------------------------------------- */
      showAddedPopup(item) {
        // Other cart types (notification / page) keep their original behaviour
        if (!this.cart || this.cart.tagName !== 'CART-DRAWER') {
          if (this.cart) this.cart.renderContents(item);
          return;
        }

        // Show the popup first (fast), then refresh drawer + header bubble in the background
        this.refreshCartInBackground();
        ProductForm.notifyApps();

        ProductForm.injectPopupStyles();

        const old = document.getElementById('added-to-cart-popup');
        if (old) old.remove();
        clearTimeout(ProductForm.popupTimer);

        const items = Array.isArray(item) ? item : [item];
        if (!items.length) return;
        const labelFor = (entry) => {
          const title = entry.product_title || entry.title || '';
          const variant = entry.variant_title && entry.variant_title !== 'Default Title' ? entry.variant_title : '';
          return [title, variant].filter(Boolean).join(' - ');
        };
        const label = items.length === 1
          ? `${labelFor(items[0])} Added to cart`
          : `${items.length} products added to cart`;

        const popup = document.createElement('div');
        popup.id = 'added-to-cart-popup';
        popup.setAttribute('role', 'status');
        popup.setAttribute('aria-live', 'polite');

        const bar = document.createElement('div');
        bar.className = 'atc-popup__bar';
        bar.textContent = label;

        const body = document.createElement('div');
        body.className = 'atc-popup__body';

        const closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'atc-popup__close';
        closeBtn.setAttribute('aria-label', 'Close');
        closeBtn.innerHTML =
          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 2l12 12M14 2L2 14"/></svg>';

        const imgWrap = document.createElement('div');
        imgWrap.className = 'atc-popup__products';
        items.forEach((entry) => {
          const itemWrap = document.createElement('div');
          itemWrap.className = 'atc-popup__product';
          const imageHolder = document.createElement('div');
          imageHolder.className = 'atc-popup__img';
          let imageUrl = (entry.featured_image && entry.featured_image.url) || entry.image || '';
          if (imageUrl) {
            try {
              const u = new URL(imageUrl, window.location.origin);
              u.searchParams.set('width', '160');
              imageUrl = u.toString();
            } catch (e) {}
            const img = document.createElement('img');
            img.src = imageUrl;
            img.alt = labelFor(entry);
            img.width = 80;
            img.height = 80;
            imageHolder.appendChild(img);
          }
          itemWrap.appendChild(imageHolder);
          if (items.length > 1) {
            const name = document.createElement('span');
            name.className = 'atc-popup__product-name';
            name.textContent = labelFor(entry);
            itemWrap.appendChild(name);
          }
          imgWrap.appendChild(itemWrap);
        });

        const viewCart = document.createElement('button');
        viewCart.type = 'button';
        // These match the "Additional selectors" configured in WeUpsell > Cart Drawer > Triggers,
        // so the app's own click trigger recognises this button as well.
        viewCart.className = 'atc-popup__view lbouge-custom-cart-btn';
        viewCart.id = 'open-usell-cart';
        viewCart.textContent = 'View cart';

        body.append(closeBtn, imgWrap, viewCart);
        popup.append(bar, body);
        document.body.appendChild(popup);

        const dismiss = () => {
          clearTimeout(ProductForm.popupTimer);
          popup.classList.remove('is-visible');
          setTimeout(() => popup.remove(), 160);
        };

        closeBtn.addEventListener('click', dismiss);
        viewCart.addEventListener('click', () => {
          if (viewCart.dataset.opening === 'true') return;
          viewCart.dataset.opening = 'true';
          // hide the popup now, but keep the button in the DOM so the app's own trigger click can still reach it
          clearTimeout(ProductForm.popupTimer);
          popup.classList.remove('is-visible');
          const removePopup = () => setTimeout(() => popup.remove(), 200);
          ProductForm.suppressUntil = 0;
          // Open the WeUpsell drawer (never the theme's). The app may still be starting up after the first
          // add-to-cart, so wait for its API instead of falling back to the theme drawer straight away.
          const themeDrawer = this.cart;
          // true only when the app really accepted the request (it returns false while it is not ready)
          const openApp = () => {
            ProductForm.suppressUntil = 0;
            ProductForm.allowOpen = true;
            try {
              let result;
              if (window.WeUpsellCart && typeof window.WeUpsellCart.open === 'function') {
                result = window.WeUpsellCart.open();
              } else if (typeof window.weupsellOpenStaticCartDrawer === 'function') {
                result = window.weupsellOpenStaticCartDrawer({ source: 'merchant_api' });
              } else {
                return false;
              }
              // an app that is not ready may return nothing at all, so only trust an explicit success
              // or the app's own "open" class on <body>
              return result === true || (result !== false && document.body.classList.contains('weupsell-static-cart-open'));
            } catch (e) {
              console.error(e);
            } finally {
              ProductForm.allowOpen = false;
            }
            return false;
          };
          const closeThemeDrawer = () => {
            if (themeDrawer.classList.contains('active')) themeDrawer.close();
          };
          const clickAppIcon = () => {
            // 1) the popup button carries the app's configured trigger selectors: let the app handle a real click
            if (viewCart.isConnected) {
              window.__lbougeAppClick = true;
              try { viewCart.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, composed: true, view: window })); }
              finally { setTimeout(() => { window.__lbougeAppClick = false; }, 0); }
            }
            // 2) the header cart icon is also one of the app's triggers
            const icon = document.getElementById('cart-icon-bubble');
            if (!icon) return false;
            window.__lbougeAppClick = true;
            try { icon.click(); } finally { setTimeout(() => { window.__lbougeAppClick = false; }, 0); }
            return true;
          };
          // The app was not told about the theme's add-to-cart, so it may refuse to open for a moment.
          ProductForm.notifyApps();
          let tries = 0;
          const attempt = () => {
            if (openApp()) {
              setTimeout(closeThemeDrawer, 350);
              removePopup();
              return;
            }
            tries++;
            if (tries === 3 || tries === 8) clickAppIcon(); // let the app handle its own trigger selector
            if (tries > 24) {
              clickAppIcon();
              removePopup();
              // last resort after ~6s: never leave the shopper stuck without a cart
              setTimeout(() => {
                if (!document.body.classList.contains('weupsell-static-cart-open')) this.cart.open(viewCart);
              }, 600);
              return;
            }
            setTimeout(attempt, 250);
          };
          attempt();
        });

        requestAnimationFrame(() => popup.classList.add('is-visible'));
        ProductForm.popupTimer = setTimeout(dismiss, 4000);
      }

      refreshCartInBackground() {
        const cart = this.cart;
        const ids = cart.getSectionsToRender().map((section) => section.id);
        const url = `${window.location.pathname}?sections=${encodeURIComponent(ids.join(','))}`;
        ProductForm.nativeFetch(url)
          .then((r) => r.json())
          .then((sections) => this.refreshCartSilently({ sections }))
          .catch((e) => console.error(e));
      }

      refreshCartSilently(parsedState) {
        const cart = this.cart;
        if (!cart || typeof cart.getSectionsToRender !== 'function' || !parsedState.sections) return;

        const inner = cart.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');

        cart.getSectionsToRender().forEach((section) => {
          const el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          const html = parsedState.sections[section.id];
          if (!el || !html) return;
          if (section.id === 'cart-icon-bubble') {
            if (typeof lbougePatchCartBubble === 'function') lbougePatchCartBubble(html);
            return;
          }
          el.innerHTML = cart.getSectionInnerHTML(html, section.selector);
        });

        // the overlay was re-rendered, so re-bind its close handler
        const overlay = cart.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof cart.close === 'function') overlay.addEventListener('click', cart.close.bind(cart));
      }

      /* The theme adds to cart through an isolated fetch (so apps cannot auto-open their drawer), which also hides
         the change from them. A no-op cart update through the normal fetch lets apps like WeUpsell re-read the cart. */
      static notifyApps() {
        try {
          fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: {} }),
          }).catch(() => {});
        } catch (e) {}
      }

      /* fetch that bypasses scripts which patch window.fetch (apps hooking /cart/add) */
      static nativeFetch(url, config) {
        try {
          if (!ProductForm.cleanFrame) {
            const f = document.createElement('iframe');
            f.style.display = 'none';
            f.setAttribute('aria-hidden', 'true');
            f.tabIndex = -1;
            document.body.appendChild(f);
            ProductForm.cleanFrame = f;
          }
          const abs = new URL(url, window.location.origin).toString();
          return ProductForm.cleanFrame.contentWindow.fetch(abs, config);
        } catch (e) {
          return fetch(url, config);
        }
      }

      /* stops the WeUpsell drawer (or any app) from opening itself right after add-to-cart */
      static suppressAutoOpen() {
        ProductForm.suppressUntil = Date.now() + 3000;

        if (!ProductForm.guardInstalled) {
          ProductForm.guardInstalled = true;
          // a real click on the header cart icon / cart link always re-allows opening
          document.addEventListener(
            'click',
            (e) => {
              if (e.target.closest && e.target.closest('#cart-icon-bubble, .header__icon--cart, a[href="/cart"], .atc-popup__view')) {
                ProductForm.suppressUntil = 0;
              }
            },
            true
          );
        }

        const wrap = (obj, key) => {
          if (!obj || typeof obj[key] !== 'function' || obj[key].__atcGuard) return;
          const orig = obj[key];
          const guarded = function () {
            if (Date.now() < ProductForm.suppressUntil && !ProductForm.allowOpen) return;
            return orig.apply(this, arguments);
          };
          guarded.__atcGuard = true;
          try {
            obj[key] = guarded;
          } catch (e) {}
        };
        const install = () => {
          wrap(window.WeUpsellCart, 'open');
          wrap(window.WeUpsellCart, 'toggle');
          wrap(window, 'weupsellOpenStaticCartDrawer');
        };
        install();
        // the app may (re)define its API a moment later, so re-check and close if it still opened
        [150, 500, 1000, 1800].forEach((ms) =>
          setTimeout(() => {
            if (Date.now() >= ProductForm.suppressUntil || ProductForm.allowOpen) return;
            install();
            try {
              if (window.WeUpsellCart && window.WeUpsellCart.close) window.WeUpsellCart.close();
            } catch (e) {}
          }, ms)
        );
      }

      static injectPopupStyles() {
        if (document.getElementById('atc-popup-styles')) return;
        const style = document.createElement('style');
        style.id = 'atc-popup-styles';
        style.textContent = `
          #added-to-cart-popup{position:fixed;top:0;left:0;right:0;z-index:9999;background:#fff;color:#000;
            box-shadow:0 2px 12px rgba(0,0,0,.12);transform:translateY(-100%);transition:transform .15s ease-out;}
          #added-to-cart-popup.is-visible{transform:translateY(0);}
          .atc-popup__bar{background:#000;color:#fff;text-align:center;font-size:1.1rem;font-weight:600;
            letter-spacing:.1rem;text-transform:uppercase;padding:.8rem 1.6rem;line-height:1.3;}
          .atc-popup__body{display:flex;align-items:center;justify-content:space-between;padding:1.2rem 2.4rem;min-height:9rem;}
          .atc-popup__products{display:flex;align-items:center;justify-content:center;gap:1rem;flex:1;min-width:0;flex-wrap:wrap;max-height:25rem;overflow:auto;}
          .atc-popup__product{display:flex;align-items:center;gap:.6rem;min-width:0;max-width:22rem;}
          .atc-popup__product-name{font-size:1.1rem;line-height:1.35;max-width:12rem;overflow-wrap:anywhere;}
          .atc-popup__img{width:8rem;height:8rem;border-radius:50%;overflow:hidden;background:#f3f3f3;flex:none;}
          .atc-popup__img img{width:100%;height:100%;object-fit:cover;display:block;}
          .atc-popup__close,.atc-popup__view{background:none;border:0;cursor:pointer;color:inherit;font:inherit;
            padding:1rem;min-width:8rem;}
          .atc-popup__close{display:flex;justify-content:flex-start;}
          .atc-popup__view{text-align:right;font-size:1.2rem;font-weight:600;letter-spacing:.1rem;text-transform:uppercase;}
          @media (max-width:749px){.atc-popup__bar{font-size:1rem;}.atc-popup__body{padding:1rem 1.2rem;}
            .atc-popup__close,.atc-popup__view{min-width:5rem;padding:.5rem;}
            .atc-popup__img{width:5.5rem;height:5.5rem;}
            .atc-popup__product-name{font-size:1rem;max-width:9rem;}
            .atc-popup__products{gap:.5rem;max-height:18rem;}}

        `;
        document.head.appendChild(style);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
